export class FirestoreMap<T> extends Map<string, T> {
    fromCache: boolean;
}
